export const FILTER_DEFAULT = "*" as const;
